import { useState, useEffect, useRef } from 'preact/hooks';
import './search-form.css';

interface SearchFormProps {
  onSearch: (query: string) => void;
  loading: boolean;
}

export function SearchForm({ onSearch }: SearchFormProps) {
  const [query, setQuery] = useState('');
  const timeoutRef = useRef<number>();

  useEffect(() => {
    if (query.length >= 2) {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = window.setTimeout(() => {
        onSearch(query);
      }, 500);
    }

    return () => {
      if (timeoutRef.current) {
        window.clearTimeout(timeoutRef.current);
      }
    };
  }, [query, onSearch]);

  const handleInput = (e: Event) => {
    const value = (e.target as HTMLInputElement).value;
    setQuery(value);
  };

  return (
    <form class="search-form" onSubmit={(e) => e.preventDefault()}>
      <input
        type="search"
        value={query}
        onInput={handleInput}
        placeholder="Search"
        class="search-input"
      />
    </form>
  );
}
